export enum ListRelationType {
  // None of the items in the list can occur at the same time
  mutuallyExclusive = 'mutuallyExclusive',
  // All of the items in the list must occur at the same time
  mutuallyInclusive = 'mutuallyInclusive'
}